// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1___388b263ee0d7ef29933","cls2":"UserTooltip-cls2___f0c8964c08867651e8f UserTooltip-cls1___388b263ee0d7ef29933"};